'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Container = require('./components/Container.Steps');

var _Container2 = _interopRequireDefault(_Container);

var _Step = require('./components/Step.Steps');

var _Step2 = _interopRequireDefault(_Step);

var _Line = require('./components/Line.Steps');

var _Line2 = _interopRequireDefault(_Line);

var _NumericIcon = require('./components/NumericIcon.Steps');

var _NumericIcon2 = _interopRequireDefault(_NumericIcon);

var _Label = require('./components/Label.Steps');

var _Label2 = _interopRequireDefault(_Label);

var _Icon = require('./components/Icon.Steps');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Components


var ManualSteps = function ManualSteps(_ref) {
  var steps = _ref.steps,
      step = _ref.step,
      onStep = _ref.onStep;
  return _react2.default.createElement(_Container2.default, null, steps.map(function (_ref2, index) {
    var key = _ref2.key,
        label = _ref2.label,
        icon = _ref2.icon,
        done = _ref2.done;
    return [index > 0 && _react2.default.createElement(_Line2.default, {
      key: index + '_line'
    }), _react2.default.createElement(_Step2.default, {
      key: key,
      onClick: function onClick() {
        return onStep(key);
      }
    }, icon ? _react2.default.createElement(_Icon2.default, {
      icon: icon,
      done: done,
      selected: key === step
    }) : _react2.default.createElement(_NumericIcon2.default, {
      step: index + 1,
      done: done,
      selected: key === step
    }), _react2.default.createElement(_Label2.default, {
      done: done
    }, label))];
  }));
};

ManualSteps.propTypes = {
  steps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.any.isRequired,
    label: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.string,
    done: _propTypes2.default.bool
  })).isRequired,
  step: _propTypes2.default.any,
  onStep: _propTypes2.default.func
};
exports.default = ManualSteps;